export const get2faConfirmationToken = (state) =>
  state?.auth?.confirmationToken;
